export enum PreferredContactMethod {
  EMAIL = 'EMAIL',
  PHONE = 'PHONE',
}

export const getPreferredContactMethodLabel = (object: PreferredContactMethod) => {
  switch (object) {
    case PreferredContactMethod.EMAIL:
      return $localize`Email`;
    case PreferredContactMethod.PHONE:
      return $localize`Phone`;
    default:
      return '';
  }
};
